import React from 'react';
import { View, Text, Image, Linking, Modal, TouchableOpacity } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import DeviceInfo from 'react-native-device-info';
import Button from '@shared/components/md-design-system/Button/Button';
import Icon from '@shared/components/md-design-system/Icon/Icon';
import { useI18n } from '@shared/i18n/useI18n';
import { Telemetry } from 'app/services/telemetry/Telemetry';

const openStore = () => {
  const bundleId = DeviceInfo.getBundleId();
  Linking.openURL(`market://details?id=${bundleId}`).catch(() =>
    Linking.openURL(`https://play.google.com/store/apps/details?id=${bundleId}`)
  );
  Telemetry.breadcrumb('force_update.open_play_store', { bundleId, type: 'user_action' });
};

interface ForceUpdateModalProps {
  visible: boolean;
  onDismiss: () => void;
}

const ForceUpdateModal: React.FC<ForceUpdateModalProps> = ({ visible, onDismiss }) => {
  const { t } = useI18n();

  return (
    <Modal visible={visible} transparent animationType="slide" onRequestClose={onDismiss}>
      <View className="flex-1 justify-end bg-black/50">
        <View className="bg-white rounded-t-3xl flex-1 mt-16">
          <SafeAreaView className="flex-1">
            <TouchableOpacity
              onPress={onDismiss}
              className="absolute top-4 right-4 z-10 w-9 h-9 rounded-full bg-gray-100 items-center justify-center"
              hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
            >
              <Icon name="close" size="md" color="#000" />
            </TouchableOpacity>
            <View className="flex-1 justify-center px-[20%] gap-4xl">
              <Image
                source={require('@assets/images/medicilio_logo.png')}
                className="w-[166px] h-[32px] self-center"
                resizeMode="contain"
              />
              <View className="gap-lg">
                <Text className="font-heading text-5xl text-black">
                  {t('screens.forceUpdate.title')}
                </Text>
                <Text className="font-body text-base text-black">
                  {t('screens.forceUpdate.body')}
                </Text>
                <Button
                  variant="primary"
                  size="large"
                  style={{ marginVertical: 0 }}
                  onPress={openStore}
                >
                  {t('screens.forceUpdate.button')}
                </Button>
              </View>
            </View>
          </SafeAreaView>
        </View>
      </View>
    </Modal>
  );
};

export default ForceUpdateModal;
